import React, { useState, useEffect } from 'react';
import Header from "../components/header/Header";
import FloatingButton from '../components/bottomtotop/FloatingButton';
import { FaCheck } from 'react-icons/fa6';
import { FaTimes } from 'react-icons/fa';
import Footer from '../components/footer/Footer';
import axiosJWT from '../../secureAPI/axiosJWT';
import { showToast } from '../../Utils/toastUtils';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import { useNavigate } from 'react-router-dom';
import { BiRupee } from 'react-icons/bi';


const Pricing = () => {

  const [openIndex, setOpenIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [isDisabled, setisDisabled] = useState(false);

  const [Mainplans, setMainplans] = useState([]);
  const [isAnnual, setIsAnnual] = useState(false);
  const [userPlanDetails, setuserPlanDetails] = useState([]);

  const [isINR, setIsINR] = useState(true);

  const [navigateStatus, setNavigateStatus] = useState(0);


  const getUsers = async () => {
    try {
      StartLoading(setIsLoading); // Starting loading spinner
      const response = await axiosJWT.post(`https://b2b.selzor.com/api/VerifyToken`, {}, { withCredentials: true });
      if (response.data.success === 1) {
        StopLoading(setIsLoading);
        setNavigateStatus(1);
        // window.location.href = 'http://localhost:3000/seller/plans/';

      } else {
        StopLoading(setIsLoading);
        showToast('Something went wrong! Please try again later', 'error');
      }
    } catch (err) {

      if (err.response && err.response.status === 401) {
        navigate('/', { replace: true });
      } else {
        StopLoading(setIsLoading);
        // window.location.href = 'http://localhost:3000/';
        setNavigateStatus(2);

        // console.log("=-=============");

        showToast('Something went wrong! Please try again later', 'error');
      }
    }
  };

  useEffect(() => {
    getUsers();
  }, [navigate]);


  const faqs = [
    {
      question: "What is a 'Seller'?",
      answer: "Every Company or Organisation that signs up for Selzor to accept orders from their customers (wholesale or otherwise), is a 'Seller'. When you sign up for Selzor as a 'Seller', you are automatically allotted our Free Plan. All the 'Paid Pricing Plans' are for 'Sellers' on the Selzor Platform."
    },
    {
      question: "What is a 'Buyer'?",
      answer: "Every Company or Organisation that signs up for Selzor to place orders to their 'Suppliers' is a 'Buyer'. This will include all your Distributors, Dealers, Wholesalers & Retailers, who place order to you. Selzor is 100% FREE for placing orders."
    },
    {
      question: "What is a 'User'?",
      answer: "There are 2 types of 'Users'. 'Paid Users' & 'Free Users'. The 'Users' referred to in the pricing table are 'Paid Users'. Every individual who registers for Selzor & manages a 'Seller' Account, either as a 'Group Owner' or otherwise, is a 'Paid User'. This includes all your staff members, who have access to manage your 'Seller' Account, as an 'Admin', 'Manager', 'Sales Rep' or 'Distributor'. On the other hand, every individual who registers for Selzor & manages a 'Buyer' Account, either as a 'Group Owner' or otherwise, is a 'Free User'. Every 'Buyer' Account comes with 5 free users."
    },
    {
      question: "Do I need to sign up for Selzor Web App & Selzor Mobile Apps separately?",
      answer: "No. You need to signup only once & then you can access your Selzor Account from our Web App & Mobile Apps (Android & iOS)."
    },
    {
      question: "Do I need to sign up for Selzor with different credentials for becoming a 'Seller' or 'Buyer'?",
      answer: "No. You need to signup only once & then you can use the same login credentials to become a 'Seller' or 'Buyer' or vice versa."
    },
    {
      question: "Can I have multiple 'Sellers' & multiple 'Buyers' in my Selzor Account?",
      answer: "Yes. Selzor supports multiple 'Sellers' & 'Buyers' with the same login credentials. Currently, you can add another 'Seller' to your account only if the existing 'Seller' is a premium seller (i.e. on a paid plan). For 'Buyers', you can add up to 3 'Buyer' accounts with the same login credentials. You can however, become a 'User' in up to 10 'Seller' & 10 'Buyer' Accounts with the same login credentials."
    },
    {
      question: "What can I do in the Selzor Free Plan?",
      answer: "When you sign up for Selzor, to take or accept orders from your customers, you are automatically allotted our Free Plan. Free Plan includes - 1 Seller, 1 User, 25 Orders per month, 5 Buyers, 1000 SKU's, 5 Custom Order Fields. Once the 25-order limit is reached in a month, you cannot receive any more orders until the new monthly cycle starts (every 30 days from your signup date)."
    },
    {
      question: "Is there any expiry limit for the Free Plan?",
      answer: "No. Currently, there is no expiry limit. You can continue to use this plan for as long as you wish. If at any time in the future, we impose any limit, we will inform you about that change in advance."
    },
    {
      question: "Do I need to make any payment upfront?",
      answer: "No. You can sign up for Selzor and create a 'Seller' or 'Buyer' account for accepting or placing orders respectively. You do not have to make any payment. Selzor is 100% FREE for placing orders. When you sign up for a 'Seller' account, you are automatically allotted our Free Plan and can use it for as long as you wish."
    },
    {
      question: "What payment options & payment gateways are available?",
      answer: "Users are redirected to PayPal to make payment. Payment options supported by PayPal include Credit Cards & PayPal Account."
    },
    {
      question: "What are Custom Order Fields?",
      answer: "Custom Order Fields are fields that allow you to personalize the ordering process for your business needs — like adding product sizes, delivery preferences, etc."
    },
    {
      question: "What is Custom App Code?",
      answer: "On becoming a 'Seller', you are allotted a Selzor App Code, which is a unique 8-digit numeric code. Your buyers use this code to add you as a Supplier & then request you to place orders. In our 'Business' & 'Business Plus' plans you get a Custom App Code, which can be used to replace this 8-digit app code with your custom brand name."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  // const middle = Math.ceil(faqs.length / 2);
  // const column1 = faqs.slice(0, middle);
  // const column2 = faqs.slice(middle)

  useEffect(() => {
    fetchPlansData();

  }, []);

  const fetchPlansData = async () => {

    try {
      StartLoading(setIsLoading, setisDisabled);
      const response = await axiosJWT.post(`https://b2b.selzor.com/api/GetPlans`);
      if (response.data.success === 1 && Array.isArray(response.data.data)) {
        // const formattedPlans = response.data.data.map(plan => ({
        //     ...plan,
        //     features: plan.features.split(','),
        // }));
        setMainplans(response.data.data);
        // setMainplans(response.data.data);
      } else {

      }


    } catch (err) {
      console.error("Failed to load new orders, please try again later ", err);
    } finally {
      StopLoading(setIsLoading, setisDisabled)
    }
    // await Promise.all([
    //     getNewOrders(),
    //     getConfirmOrders(),
    //     getOnHoldOrders(),
    //     getOnProcessOrders(),
    //     getCompletedOrders(),
    //     getCancelledOrders()
    // ]);

  };


  const uniqueFeaturess = [
    "Selzor Branded Web & Mobile App (Android)",
    "Seller (Company / Organisation)",
    "Users Included (Admin Account)",
    "Total Orders",
    "Buyers / Customers",
    "Custom Order Fields"
  ];


  const handleNavigate = (check) => {
    if (check === 1) {
      window.location.href = 'https://b2b.selzor.com/seller/plans/';
    }
    else {
      window.location.href = 'https://b2b.selzor.com/';
    }
  }


  return (
    <div>
      <Header />
      <section className='mx-auto max-w-screen-2xl px-6 sm:px-5 md:px-0 lg:px-0'>
        <div className="bg-white py-12 sm:py-16 lg:py-20">
          <div className=''>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-700 mb-2 sm:mb-3">
              Clear and transparent pricing, no hidden fees
            </h2>
            <p className="text-gray-600 text-base sm:text-lg mb-8 sm:mb-12">
              Selzor's pricing is straightforward and transparent — no unexpected charges.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row justify-center  items-center gap-6 mb-12">
            {/* <div className='w-auto border py-1 border-[#1a9588] rounded-full'>
              <div className="pricing-switcher bg-gray-100 rounded-full p-1 inline-flex">
                <div className="fieldset relative">
                  <input
                    id="pricingPlan"
                    name="pricingPlan"
                    type="radio"
                    value="monthly"
                    checked={pricingPlan === 'monthly'}
                    onChange={() => togglePricingPlan('monthly')}
                    className="absolute opacity-0 w-0 h-0"
                  />
                  <label
                    htmlFor="pricingPlan"
                    className={`px-6 py-2 rounded-full cursor-pointer font-semibold ${pricingPlan === 'monthly' ? 'bg-[#1a9588] text-white' : 'text-gray-700'}`}
                  >
                    Monthly
                  </label>
                  <input
                    id="pricingPlan2"
                    name="pricingPlan"
                    type="radio"
                    value="yearly"
                    checked={pricingPlan === 'yearly'}
                    onChange={() => togglePricingPlan('yearly')}
                    className="absolute opacity-0 w-0 h-0"
                  />
                  <label
                    htmlFor="pricingPlan2"
                    className={`px-6 py-2 rounded-full cursor-pointer font-semibold ${pricingPlan === 'yearly' ? 'bg-[#1a9588] text-white' : 'text-gray-700'}`}
                  >
                    Yearly
                  </label>
                </div>
              </div>
            </div> */}

            {/* <div className='w-auto border py-1 border-[#1a9588] rounded-full'>
              <div className="currency-switcher bg-gray-100 rounded-full p-1 inline-flex">
                <div className="fieldset relative">
                  <input
                    id="currencyInr"
                    name="currency"
                    type="radio"
                    value="inr"
                    checked={currency === 'inr'}
                    onChange={() => toggleCurrency('inr')}
                    className="absolute opacity-0 w-0 h-0"
                  />
                  <label
                    htmlFor="currencyInr"
                    className={`px-6 py-2 rounded-full cursor-pointer font-semibold ${currency === 'inr' ? 'bg-[#1a9588] text-white' : 'text-gray-700'}`}
                  >
                    INR
                  </label>
                  <input
                    id="currencyDollar"
                    name="currency"
                    type="radio"
                    value="dollar"
                    checked={currency === 'dollar'}
                    onChange={() => toggleCurrency('dollar')}
                    className="absolute opacity-0 w-0 h-0"
                  />
                  <label
                    htmlFor="currencyDollar"
                    className={`px-6 py-2 rounded-full cursor-pointer font-semibold ${currency === 'dollar' ? 'bg-[#1a9588] text-white' : 'text-gray-700'}`}
                  >
                    Dollar
                  </label>
                </div>
              </div>
            </div> */}


            {/* <div className="flex justify-center">
              <div className="relative flex w-[200px] p-1 bg-white rounded-full border border-[#1a9588] shadow-md">
                <span className="absolute inset-0 m-1 pointer-events-none">
                  <span
                    className={`absolute top-0 left-0 w-1/2 h-[calc(100%-0px)] bg-gradient-to-r from-[#1a9588] to-[#20c997] rounded-full shadow-lg transform transition-transform duration-300 ease-in-out ${isINR ? "translate-x-0" : "translate-x-full"
                      }`}
                  />
                </span>

                <button
                  className={`relative flex-1 text-base font-semibold py-2 rounded-full z-10 transition-colors duration-200 ${isINR ? "text-white" : "text-gray-600 hover:text-[#1a9588]"
                    }`}
                  onClick={() => setIsINR(true)}
                >
                  INR
                </button>

                <button
                  className={`relative flex-1 text-base font-semibold py-2 rounded-full z-10 transition-colors duration-200 ${!isINR ? "text-white" : "text-gray-600 hover:text-[#1a9588]"
                    }`}
                  onClick={() => setIsINR(false)}
                >
                  Dollar
                </button>
              </div>
            </div> */}
          </div>


          {/* <div className="pricingPlanTableArea hidden md:block">
            <div className="pricingTableForDesktop">
              <table className="price-table w-full border-collapse">
                <thead>
                  <tr className="price-header-tr">
                    <td className="border-b border-gray-200"></td>
                    <td className="price border-b border-gray-200 p-6 text-center">
                      <h4 className="text-xl sm:text-3xl font-medium pb-2 sm:pb-3 text-gray-700">Lite</h4>
                      <p className="text-gray-500 text-sm font-semibold mb-4">Starts your journey with essential tools</p>
                      <div className="price price1 mb-4">
                        {getPriceText('lite')}
                      </div>
                      <a href="#!" className="bg-[#1a9588] text-white px-6 py-2 rounded-full hover:shadow-xl inline-block mb-2 hover:bg-[#28b5a6] transition">
                        Sign Up
                      </a>
                      <small className="text-xs italic text-gray-500 block">Additional charges may apply</small>
                    </td>
                    <td className="price border-b border-gray-200 p-6 text-center">
                      <h4 className="text-xl sm:text-3xl font-medium pb-2 sm:pb-3 text-gray-700">Professional</h4>
                      <p className="text-gray-500 text-sm font-semibold mb-4">Automate Sales, Marketing & close more Deals</p>
                      <div className="price price1 mb-4">
                        {getPriceText('professional')}
                      </div>
                      <a href="#!" className="bg-[#1a9588] text-white px-6 py-2 rounded-full hover:shadow-xl inline-block mb-2 hover:bg-[#28b5a6] transition">
                        Sign Up
                      </a>
                      <small className="text-xs italic text-gray-500 block">Additional charges may apply</small>
                    </td>
                    <td className="price border-b border-gray-200 p-6 text-center relative">
                      <h4 className="text-xl sm:text-3xl font-medium pb-2 sm:pb-3 text-gray-700">Business</h4>
                      <p className="text-gray-500 text-sm font-semibold mb-4">Accelerate growth with innovative solutions.</p>
                      <div className="price price1 mb-4">
                        {getPriceText('business')}
                      </div>
                      <a href="#!" className="bg-[#1a9588] text-white px-6 py-2 rounded-full hover:shadow-xl inline-block mb-2 hover:bg-[#28b5a6] transition">
                        Sign Up
                      </a>
                      <small className="text-xs italic text-gray-500 block">Additional charges may apply</small>
                    </td>
                    <td className="price border-b border-gray-200 p-6 text-center">
                      <h4 className="text-xl sm:text-3xl font-medium pb-2 sm:pb-3 text-gray-700">Business Plus</h4>
                      <p className="text-gray-500 text-sm font-semibold mb-4">Build & Organize your Sales Function</p>
                      <div className="price price1 mb-4">
                        {getPriceText('businessPlus')}
                      </div>
                      <a href="#!" className="bg-[#1a9588] text-white px-6 py-2 rounded-full hover:shadow-xl inline-block mb-2 hover:bg-[#28b5a6] transition">
                        Sign Up
                      </a>
                      <small className="text-xs italic text-gray-500 block">Additional charges may apply</small>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {pricingFeatures.map((feature, index) => (
                    <tr key={index} className="price-table-body-tr border-b border-gray-200">
                      <td className="p-4 font-medium text-start">{feature.name}</td>
                      <td className="p-4 text-center">
                        {typeof feature.lite === 'boolean' ? (
                          feature.lite ? <FaCheck className="text-green-500 mx-auto" /> : <FaTimes className="text-red-500 mx-auto" />
                        ) : (
                          feature.lite
                        )}
                      </td>
                      <td className="p-4 text-center">
                        {typeof feature.professional === 'boolean' ? (
                          feature.professional ? <FaCheck className="text-green-500 mx-auto" /> : <FaTimes className="text-red-500 mx-auto" />
                        ) : (
                          feature.professional
                        )}
                      </td>
                      <td className="p-4 text-center">
                        {typeof feature.business === 'boolean' ? (
                          feature.business ? <FaCheck className="text-green-500 mx-auto" /> : <FaTimes className="text-red-500 mx-auto" />
                        ) : (
                          feature.business
                        )}
                      </td>
                      <td className="p-4 text-center">
                        {typeof feature.businessPlus === 'boolean' ? (
                          feature.businessPlus ? <FaCheck className="text-green-500 mx-auto" /> : <FaTimes className="text-red-500 mx-auto" />
                        ) : (
                          feature.businessPlus
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="price-header-tr">
                    <td className="border-b border-gray-200"></td>
                    <td className="price border-b border-gray-200 p-6 text-center">
                      <p className="para text-gray-600 mb-2">Total Price</p>
                      <div className="price mb-4">
                        <div className="amount font-bold">
                          <span className="sign">{getCurrencySign(currency)}</span> <span>{getPrice('lite', pricingPlan, currency)}</span>
                        </div>
                      </div>
                      <a href="#!" className="bg-[#1a9588] text-white px-6 py-2 rounded-full hover:shadow-xl inline-block mb-2 hover:bg-[#28b5a6] transition">
                        Sign Up
                      </a>
                      <small className="text-xs italic text-gray-500 block">Additional charges may apply</small>
                    </td>
                    <td className="price border-b border-gray-200 p-6 text-center">
                      <p className="para text-gray-600 mb-2">Total Price</p>
                      <div className="price mb-4">
                        <div className="amount font-bold">
                          <span className="sign">{getCurrencySign(currency)}</span> <span>{getPrice('professional', pricingPlan, currency)}</span>
                        </div>
                      </div>
                      <a href="#!" className="bg-[#1a9588] text-white px-6 py-2 rounded-full hover:shadow-xl inline-block mb-2 hover:bg-[#28b5a6] transition">
                        Sign Up
                      </a>
                      <small className="text-xs italic text-gray-500 block">Additional charges may apply</small>
                    </td>
                    <td className="price border-b border-gray-200 p-6 text-center">
                      <p className="para text-gray-600 mb-2">Total Price</p>
                      <div className="price mb-4">
                        <div className="amount font-bold">
                          <span className="sign">{getCurrencySign(currency)}</span> <span>{getPrice('business', pricingPlan, currency)}</span>
                        </div>
                      </div>
                      <a href="#!" className="bg-[#1a9588] text-white px-6 py-2 rounded-full hover:shadow-xl inline-block mb-2 hover:bg-[#28b5a6] transition">
                        Sign Up
                      </a>
                      <small className="text-xs italic text-gray-500 block">Additional charges may apply</small>
                    </td>
                    <td className="price border-b border-gray-200 p-6 text-center">
                      <p className="para text-gray-600 mb-2">Total Price</p>
                      <div className="price mb-4">
                        <div className="amount font-bold">
                          <span className="sign">{getCurrencySign(currency)}</span> <span>{getPrice('businessPlus', pricingPlan, currency)}</span>
                        </div>
                      </div>
                      <a href="#!" className="bg-[#1a9588] text-white px-6 py-2 rounded-full hover:shadow-xl inline-block mb-2 hover:bg-[#28b5a6] transition">
                        Sign Up
                      </a>
                      <small className="text-xs italic text-gray-500 block">Additional charges may apply</small>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div> */}


          <div className="pricingPlanTableArea hidden md:block">
            <div className="pricingTableForDesktop">

              <table className="price-table w-full border-collapse">
                {/* <thead>
                  <tr className="price-header-tr">
                    <td className="border-b border-gray-200"></td>
                    {Mainplans.map((planss) => (
                      <td key={planss.id} className="price border-b border-gray-200 p-6 text-center">
                        <h4 className="text-xl sm:text-3xl font-medium pb-2 sm:pb-3 text-gray-700">
                          {planss.plan_name}
                        </h4>
                        <div className="price price1 mb-4">
                          <span className="currency font-bold text-3xl">

                            <div className="inline-flex items-baseline mb-2">
                              <span className="text-slate-500 font-medium">
                                {isINR ? <BiRupee /> : '$'}
                              </span>

                              <span className="text-slate-500 font-medium">
                                {isAnnual
                                  ? (isINR ? planss.inr_price_monthly * 12 : planss.price_monthly * 12)
                                  : (isINR ? planss.inr_price_monthly : planss.price_monthly)
                                }
                              </span>
                              
                            </div>
                         
                          </span>
                        </div>

                        <div>

                          <button
                            type="button"
                            className="relative  inline-flex justify-center items-center rounded-lg px-8 py-3 text-sm font-semibold text-white shadow-lg shadow-indigo-950/10 bg-[#1a9588] hover:scale-105 hover:shadow-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1a9588]/50 transition-all duration-300 ease-in-out"
                          >
                            <span className="relative z-10">Sign In</span>

                           
                            <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent rounded-lg translate-x-[-100%] hover:translate-x-[100%] transition-transform duration-700 ease-in-out" />
                          </button>
                          
                        </div>

                        <small className="text-xs italic text-gray-500 block mt-4">Additional charges may apply</small>
                      </td>
                    ))}
                  </tr>
                </thead> */}

                <thead>
                  <tr className="price-header-tr">
                    <td className="border-b border-gray-200"></td>
                    {Mainplans.map((planss) => (
                      <td
                        key={planss.id}
                        className="p-6 text-center align-top border-b border-gray-200"
                      >
                        <div className="bg-white rounded-2xl  transition-shadow duration-300 p-6 flex flex-col items-center relative group">
                          {/* Plan Name */}
                          <h4 className="text-2xl sm:text-3xl font-semibold text-gray-800 mb-4">
                            {planss.plan_name}
                          </h4>

                          {/* Price Section */}
                          <div className="flex items-baseline justify-center mb-6">
                            <span className="text-gray-500 mr-1">
                              {isINR ? <BiRupee size={22} /> : '$'}
                            </span>
                            <span className="text-4xl font-bold text-gray-900">
                              {isAnnual
                                ? (isINR
                                  ? planss.inr_price_monthly * 12
                                  : planss.price_monthly * 12)
                                : (isINR
                                  ? planss.inr_price_monthly
                                  : planss.price_monthly)}
                            </span>
                            <span className="text-sm text-gray-500 ml-1">
                              {isAnnual ? "/yr" : "/mo"}
                            </span>
                          </div>

                          {/* Call to Action Button */}
                          <button
                            type="button"
                            className="relative inline-flex justify-center items-center rounded-xl px-8 py-3 text-sm font-semibold text-white shadow-lg bg-gradient-to-r from-[#1a9588] to-[#0f766e] hover:scale-105 hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-[#1a9588]/50 transition-all duration-300 ease-in-out" onClick={() => { handleNavigate(navigateStatus) }}
                          >
                            <span className="relative z-10">{navigateStatus === 1 ? "Go To Plan Detail" : "Sign In"}</span>
                            <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent rounded-xl translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out" />
                          </button>

                          {/* Additional Info */}
                          <small className="text-xs italic text-gray-500 block mt-4">
                            Additional charges may apply
                          </small>
                        </div>
                      </td>
                    ))}
                  </tr>
                </thead>

                {/* <tbody>
                  {uniqueFeaturess.map(feature => (
                    <tr key={feature} className="price-table-body-tr border-b border-gray-200">
                      <td className="p-4 font-medium text-start">
                        {feature}
                        {feature.includes("Users Included") && (
                          <div className="text-xs text-gray-500 mt-1">
                            (Buy Additional Users @ ₹1600/user/month)
                          </div>
                        )}

                        {feature.includes("Total Orders") && (
                          <div className="text-sm text-gray-500 mt-1">
                            (Buy Additional 100 Orders @ ₹2.5 per order)
                          </div>
                        )}

                      </td>

                      {Mainplans.map(plan => {
                        let valueToShow = null;

                        // Feature wise data mapping
                        if (feature.includes("Users Included")) {
                          valueToShow = plan.plan_user;
                        } else if (feature.includes("Total Orders")) {
                          valueToShow = plan.plan_orders;
                        } 
                        // else if (feature.includes("Buyers / Customers")) {
                        //   valueToShow = plan.buyers;
                        // } else if (feature.includes("Custom Order Fields")) {
                        //   valueToShow = plan.custome_field;
                        // }

                        return (
                          <td key={plan.id} className="border p-3 text-center">
                            {valueToShow !== null ? (
                              <span className="font-semibold">{valueToShow}</span>
                            ) : (
                              // Selzor App & Seller => Always True
                              (feature.includes("Selzor") || feature.includes("Seller")) ? (
                                <FaCheck className="text-green-500 mx-auto" />
                              ) : (
                                <FaTimes className="text-red-500 mx-auto" />
                              )
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody> */}

                <tbody>
  {uniqueFeaturess
    .filter(feature => 
      !feature.includes("Buyers / Customers") &&
      !feature.includes("Custom Order Fields")
    )
    .map(feature => (
      <tr key={feature} className="price-table-body-tr border-b border-gray-200">
        <td className="p-4 font-medium text-start">
          {feature}

          {feature.includes("Users Included") && (
            <div className="text-xs text-gray-500 mt-1">
              (Buy Additional Users @ ₹1600/user/month)
            </div>
          )}

          {feature.includes("Total Orders") && (
            <div className="text-sm text-gray-500 mt-1">
              (Buy Additional 100 Orders @ ₹2.5 per order)
            </div>
          )}
        </td>

        {Mainplans.map(plan => {
          let valueToShow = null;

          if (feature.includes("Users Included")) {
            valueToShow = plan.plan_user;
          } else if (feature.includes("Total Orders")) {
            valueToShow = plan.plan_orders;
          }

          return (
            <td key={plan.id} className="border p-3 text-center">
              {valueToShow !== null ? (
                <span className="font-semibold">{valueToShow}</span>
              ) : (
                (feature.includes("Selzor") || feature.includes("Seller")) ? (
                  <FaCheck className="text-green-500 mx-auto" />
                ) : (
                  <FaTimes className="text-red-500 mx-auto" />
                )
              )}
            </td>
          );
        })}
      </tr>
    ))}
</tbody>

              </table>
            </div>
          </div>




          <div className="pricingTableForMobile md:hidden">
            <div className="pricingTableBoxArea">
              <div className="grid grid-cols-1 gap-6">

                {Mainplans.map((plan) => (
                  <div key={plan.id} className="pricingTableBox border border-gray-200 rounded-lg overflow-hidden">
                    <div className="pricingTableBoxinner">
                      <div className="pricingTableLabel bg-purple-100 text-purple-800 py-2 px-4 font-bold">
                        {plan.plan_name}
                      </div>
                      <div className="p-6">
                        {/* Price */}
                        <div className="price price1 mb-4 text-center">
                          <div className='flex'>
                            <span className="currency font-bold text-3xl">
                              {isINR ? <BiRupee /> : '$'}
                            </span>

                            <span className="currency font-bold text-3xl">

                              {isAnnual
                                ? (isINR ? plan.inr_price_monthly * 12 : plan.price_monthly * 12)
                                : (isINR ? plan.inr_price_monthly : plan.price_monthly)
                              }
                            </span>
                          </div>
                        </div>

                        <div className="pricingTableFeatures space-y-4 mb-6">
                          {uniqueFeaturess.map((feature, index) => {

                            let valueToShow = null;

                            // Feature wise data mapping
                            if (feature.includes("Users Included")) {
                              valueToShow = plan.plan_user;
                            } else if (feature.includes("Total Orders")) {
                              valueToShow = plan.plan_orders;
                            }
                            //  else if (feature.includes("Buyers / Customers")) {
                            //   valueToShow = plan.buyers;
                            // } else if (feature.includes("Custom Order Fields")) {
                            //   valueToShow = plan.custome_field;
                            // }

                            return (
                              <div key={index} className="pricingTableFeaturesItem">
                                <div className="flex justify-between items-center text-start">
                                  <div className="leftSide">
                                    <p className="mb-0 font-medium">{feature}</p>
                                  </div>
                                  <div className="rightSide">
                                    {valueToShow !== null ? (
                                      <span>{valueToShow}</span>
                                    ) : (feature.includes("Selzor") || feature.includes("Seller")) ? (
                                      <FaCheck className="text-green-500" />
                                    ) : (
                                      <FaTimes className="text-red-500" />
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}

                          {/* Total Price Footer */}
                          <div className="pricingTableFeaturesItem total pt-4 border-t border-gray-200">
                            <div className="flex justify-between items-center text-start">
                              <div className="leftSide">
                                <p className="mb-0 font-bold">Total</p>
                              </div>
                              <div className="rightSide">
                                {plan.is_inr ? `₹${plan.inr_price_monthly * 12}` : `$${plan.price_monthly * 12}`} / year
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* CTA Button */}
                        <div>
                          {userPlanDetails.length > 0 ? (
                            userPlanDetails[0].plan_name === plan.plan_name ? (
                              <button
                                type="button"
                                className="w-full inline-flex justify-center whitespace-nowrap rounded-lg bg-[#707070] px-3.5 py-2.5 text-sm font-medium text-white shadow-sm shadow-indigo-950/10 hover:bg-[#707070] focus-visible:outline-none focus-visible:ring focus-visible:ring-indigo-300 focus-visible:ring-slate-600 transition-colors duration-150 cursor-not-allowed"
                                disabled
                              >
                                Current Plan
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="w-full inline-flex justify-center whitespace-nowrap rounded-lg  px-3.5 py-2.5 text-sm font-medium text-white shadow-sm shadow-indigo-950/10 bg-button-color  hover:bg-button-color focus-visible:outline-none focus-visible:ring focus-visible:ring-indigo-300 focus-visible:ring-slate-600 transition-colors duration-150"
                              // onClick={() => navigatePlanCart(plan.unique_id, isINR)}
                              >
                                Upgrade Plan
                              </button>
                            )
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

              </div>
            </div>
          </div>



        </div>
      </section>

      <section className="max-w-7xl mx-auto mt-20 px-4 sm:px-6">
        <div className='text-start'>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-gray-700 mb-2 sm:mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-600 text-sm sm:text-base md:text-lg mb-6 sm:mb-8 md:mb-12">
            With advanced analytics and reporting, you can track customer behavior, sales trends, & many more to make
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4 text-start">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className={`rounded-2xl sm:rounded-3xl px-4 sm:px-6 py-3 sm:py-4 md:py-5 transition-colors ${isOpen ? "bg-[#dbf4f1]" : "bg-[#dbf4f1]"
                  }`}
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex justify-between items-center text-left text-base sm:text-lg md:text-xl font-medium text-gray-800 focus:outline-none"
                >
                  <span className="pr-2">{faq.question}</span>
                  <svg
                    className={`w-5 h-5 sm:w-6 sm:h-6 text-gray-600 transform transition-transform duration-300 ${isOpen ? "rotate-180" : ""
                      }`}
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7"></path>
                  </svg>
                </button>
                {isOpen && (
                  <p className="mt-3 sm:mt-4 md:mt-6 text-gray-700 text-sm sm:text-base leading-relaxed">
                    {faq.answer.includes("PayPal") ? (
                      faq.answer.split("PayPal").map((part, idx, arr) => (
                        <span key={idx}>
                          {part}
                          {idx < arr.length - 1 && (
                            <a
                              href="https://www.paypal.com"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-600 underline"
                            >
                              PayPal
                            </a>
                          )}
                        </span>
                      ))
                    ) : (
                      faq.answer
                    )}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </section>
      <FloatingButton />
      <Footer />
    </div>
  );
};

export default Pricing;
